import { httpClient } from '../http/httpClient'

export type HandleCustomerStatusResponse = object

export interface HandleCustomerStatusParams {
  id: string
  action: 'archive' | 'unarchive' | 'contact'
}

export async function handleCustomerStatus({
  id,
  ...body
}: HandleCustomerStatusParams) {
  const { data } = await httpClient
    .put<HandleCustomerStatusResponse>(`customer/${id}`, body)
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
